module.exports = __webpack_public_path__ + "img/vertical_3_1_8023.87cfd59a.png";